import MediaGalleryImage from './MediaGalleryImage';

export default MediaGalleryImage;
